export default __webpack_public_path__ + "static/media/Ali.e50a88ad.jpg";